module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-4-photo-1-06876cecd6ed54188a38298c2564f845.webp";